module.exports = __webpack_public_path__ + "img/analytics-download-vector.420ad5f7.svg";